import { CourseAssociatedCurriculaController } from './course-associated-curricula.controller';
import { CourseAssociatedCurriculaProps } from './course-associated-curricula.model';

export const CourseAssociatedCurriculaPage = (
  props: CourseAssociatedCurriculaProps
) => {
  return <CourseAssociatedCurriculaController {...props} />;
};
